export default __webpack_public_path__ + "static/14-1ab9b1867852a2fecbce0470f2127811.jpg";